// extracted by css-extract-rspack-plugin
export default {"text":"LegendLabel-module__text___IiwSx","link":"LegendLabel-module__link___WrVjG"};